import BackToTop from '@/components/common/back-to-top/BackToTop.component.vue';
import Footer from '@/components/common/footer/Footer.vue';
import Navbar from '@/components/common/navbar/Navbar.vue';
import { disclaimer } from '@/lang/nl';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: {
    Navbar,
    Footer,
    BackToTop,
  },
  metaInfo: {
    title: 'Disclaimer',
  },
})

export default class Disclaimer extends Vue {
  disclaimer: {title: string, text: string}[] = disclaimer;
}
